export const REVOL_MAIN_URL = "https://revolucionstyle.com/";

export const CF_API_CACHE_MS = 1000;
